$(() => {
	URI.init();

	// Utils
	var mobile = false;
	var searchLoadingWrapper;
	if ($(window).width() <= 768) {
		mobile = true;
		window.mobile = true;
	}

	(function($) {
		$.fn.donetyping = function(callback) {
			var _this = $(this);
			var x_timer;
			_this.keyup(function() {
				clearTimeout(x_timer);
				x_timer = setTimeout(clear_timer, 300);
			});

			function clear_timer() {
				clearTimeout(x_timer);
				callback.call(_this);
			}
		};
	})(jQuery);

	function search(value, page) {
		let input = value;
		var lastPage;
		// console.log('search: ' + page);
		if (input != lastInput || page != lastPage) {
			if (searchLoadingWrapper) {
				searchLoadingWrapper.show();
			}
			$('.s-r-wrapper').hide();
			// $(`${resultElement}`).html('');

			if (!mobile) {
				var calc = $('.h-topbar').height() + $('.h-t-notice').height() + 30;
				$('.dropdown-search').css('top', calc + 'px').show();
				navOpened = true;
			} else {
				$('.search-result-mobile').html('');
			}
			$.post(
				'/P5fw/acmanager',
				{
					action: 'home/get_pesquisa',
					input: input,
					mobile: mobile,
					page: page
				},
				function(r: any) {
					if (r) {
						$(`${resultElement}`).html(r);
						$('.s-r-wrapper').show();
						if (mobile) {
							$(`${resultElement} .s-r-wrapper`).addClass('search-result-mobile');
						} else {
							searchLoadingWrapper = $('.h-l-s-wrapper');
							searchLoadingWrapper.hide();
							$('.dropdown-search').show();
						}
						navOpened = true;
						lastPage = page;
					}
				}
			);
			lastInput = input;
		}
	}
	// End Utils

	// ------------------------------------------------ PopUP's
	if ($('#popupModal').length === 1) {
		(<any>$('#popupModal')).modal('show');
	}

	var navMain = $('.navbar-collapse');
	navMain.on('click', 'a:not([data-toggle])', null, function() {
		navMain.collapse('hide');
	});

	// ------------------------------------------------ Navbar sticky scroll & Nav handler
	$('body').click(function(event) {
		if (
			(navOpened && event.target !== $('#menu-mobile')) ||
			(navOpened && event.target !== $('#search')) ||
			(navOpened && event.target !== $('.s-p-prev')) ||
			(navOpened && event.target !== $('.s-p-next')) ||
			(navOpened && event.target !== $('.search-result')) ||
			(navOpened && event.target !== $('.dropdown-search'))
		) {
			closeNav('menu-mobile');
		}
	});
	$('document').on('URIchanged', () => {
		console.log('aaaaaa');
	});

	// ------------------------------------------------ Sidenav & Sidebar
	var navOpened = false;
	let openNav = function(el) {
		if (el !== 'search-mobile') {
			$(`#${el}`).css('width', '60%');
		} else {
			$(`#${el}`).css('width', '100%');
		}
		$('#overlay').fadeIn('fast');
		setTimeout(function() {
			navOpened = true;
		}, 300);
	};

	let closeNav = function(el) {
		$(`#${el}`).css('width', '0');
		$('#overlay').fadeOut('fast');
		$('.dropdown-search').hide();
		setTimeout(function() {
			navOpened = false;
		}, 300);
	};

	// ------------------------------------------------ Mobile Menu

	$('.menu-mobile-btn').off('click');
	$('.menu-mobile-btn').on('click', function() {
		openNav('menu-mobile');
	});
	$('.menu-mobile-closebtn').off('click');
	$('.menu-mobile-closebtn').on('click', function() {
		closeNav('menu-mobile');
	});

	$('.nav-link').off('click');
	$('.nav-link').on('click', function() {
		closeNav('menu-mobile');
	});

	// ------------------------------------------------ Search
	$('#search-btn').click(function() {
		let search: any = $('#search').val();
		if (search.length > 2) {
			window.location.href = '/#/busca/' + encodeURIComponent(search);
		}
	});

	$('#search').keyup(function(event: any) {
		if (event.keyCode == 13) {
			let search: any = $('#search').val();
			if (search.length > 2) {
				window.location.href = '/#/busca/' + encodeURIComponent(search);
			}
		}
	});

	$('#search-btn-m').click(function() {
		let search: any = $('#search-m').val();
		if (search.length > 2) {
			window.location.href = '/#/busca/' + encodeURIComponent(search);
		}
	});

	$('.menu-mobile-btn-search').off('click');
	$('.menu-mobile-btn-search').on('click', function() {
		openNav('search-mobile');
	});
	$('.closebtn-search').off('click');
	$('.closebtn-search').on('click', function() {
		closeNav('search-mobile');
	});

	var lastInput = '';
	if (mobile) {
		var selector = '#search-mobile-input';
		var resultElement = '.search-mobile-result';
		$('#search-mobile').on('click', '.s-m-load-more', function() {
			var page = $(this).data('page');
			search($(`${selector}`).val(), page);
		});
	} else {
		var selector = '.s-w-input';
		var resultElement = '.search-result';
		$('.search-result').on('click', '.s-p-next, .s-p-prev', function() {
			var page = $(this).data('page');
			search($(`${selector}`).val(), page);
			setTimeout(function() {
				navOpened = true;
			}, 1000);
		});
	}

	$(`${selector}`).donetyping(function(event) {
		if ($(`${selector}`).val().length >= 3) {
			search($(this).val(), 1);
		}
	});

	$(`${selector}`).click(function() {
		if ($.trim($(`${resultElement}`).html()) != '') {
			$('.dropdown-search').show();
			setTimeout(function() {
				navOpened = true;
			}, 1000);
		}
	});
});
